module.exports = __webpack_public_path__ + "fonts/SourceSansPro-Regular.ttf.713df4a9.woff2";